module.exports = __webpack_public_path__ + "img/stt_kurang_bayar.f6f193dd.svg";